module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-2.c08ae5af.jpg";